import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PortalAccountsTable from './portal-accounts-table.jsx';


if (document.getElementById('react-component-g4-logistics-portal-portal-admin-portal-super-admins')) {
  ReactDOM.render(<PortalAccountsTable
    url= "/api/v1/portal/portal-admin/portal-super-admins"
    message_if_none = 'No portal super admins yet.'
  />,
document.getElementById('react-component-g4-logistics-portal-portal-admin-portal-super-admins'));
}
